<mat-tab-group [(selectedIndex)]="currentIndex" (selectedTabChange)="loadTabData($event.index)">
  <mat-tab *ngFor="let tab of tabs(); let i = index" [label]="tab.label">
    <div *ngIf="loading && !loadedTabs[i]" style="height: 100%;">
      <app-loading-skeleton [rows]="getSkeletonRows(tab.label)" [type]="tab.label"></app-loading-skeleton>
    </div>
    <div *ngIf="!loading && loadedTabs[i]" style="height: 100%;">
      <ng-container
        *ngComponentOutlet="tab.component; 
        inputs: {
          data: tabData[i],
          params: paramData[i],
          lead: tab.forwardLeadAllowed ? lead() : null,
          isModal: isModal() || false
        }">
      </ng-container>
    </div>
  </mat-tab>
</mat-tab-group>